import { $line_size_border_primary, $line_size_border_secondary } from '../pebbleGlobalToken/border.js';
import { $color_grey_5, $color_grey_8 } from '../pebbleGlobalToken/color.js';

/**
 * 复选框-用于控制组件边框、分割线等的宽度
 * @description enDesc: -
 * @description type: Border
 * @description value: $line_size_border_primary
 */
var $checkbox_line_width = $line_size_border_primary;

/**
 * 复选框-描边类组件的默认线宽，如 Button、Input、Select 等输入类控件。
 * @description enDesc: -
 * @description type: Border
 * @description value: $line_size_border_secondary
 */
var $checkbox_line_width_bold = $line_size_border_secondary;

/**
 * 复选框-默认使用的边框颜色, 用于分割不同的元素，例如：表单的分割线、卡片的分割线等。
 * @description enDesc: -
 * @description type: Border
 * @description value: $color-grey-5
 */
var $checkbox_color_border = $color_grey_5;

/**
 * 复选框-默认使用的边框hover颜色
 * @description enDesc: -
 * @description type: Border
 * @description value: $color-grey-8
 */
var $checkbox_color_border_hover = $color_grey_8;

export { $checkbox_color_border, $checkbox_color_border_hover, $checkbox_line_width, $checkbox_line_width_bold };
